import m from "../../geodata/es2015/serbiaLow";
window.am4geodata_serbiaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/serbiaLow.js
// module id = null
// module chunks = 